import { providerType } from '@repo/shared/types';
export function getP24MarketingAgreements(marketingData) {
    return marketingData === null || marketingData === void 0 ? void 0 : marketingData.filter(function (agreement) { return agreement.provider === providerType.enum.przelewy24; });
}
